__turbopack_context__.v({
  "page_transition": "PageTransition-module-scss-module__3E4t1q__page_transition",
});
